export class Input {
  readonly keys = new Set<string>();
  readonly down = new Set<string>();
  readonly up = new Set<string>();
  mx = 0;
  my = 0;
  wheel = 0;
  fire = false;
  ads = false;
  locked = false;
  private canvas: HTMLCanvasElement;

  constructor(canvas: HTMLCanvasElement) {
    this.canvas = canvas;
    window.addEventListener("keydown", this.onKeyDown);
    window.addEventListener("keyup", this.onKeyUp);
    window.addEventListener("mousedown", this.onMouseDown);
    window.addEventListener("mouseup", this.onMouseUp);
    window.addEventListener("mousemove", this.onMouseMove);
    window.addEventListener("wheel", this.onWheel, { passive: true });
    document.addEventListener("pointerlockchange", this.onLock);
    window.addEventListener("blur", this.clear);
  }

  dispose() {
    window.removeEventListener("keydown", this.onKeyDown);
    window.removeEventListener("keyup", this.onKeyUp);
    window.removeEventListener("mousedown", this.onMouseDown);
    window.removeEventListener("mouseup", this.onMouseUp);
    window.removeEventListener("mousemove", this.onMouseMove);
    window.removeEventListener("wheel", this.onWheel);
    document.removeEventListener("pointerlockchange", this.onLock);
    window.removeEventListener("blur", this.clear);
  }

  requestLock() {
    this.canvas.requestPointerLock();
  }

  exitLock() {
    if (document.pointerLockElement) document.exitPointerLock();
  }

  endFrame() {
    this.mx = 0;
    this.my = 0;
    this.wheel = 0;
    this.down.clear();
    this.up.clear();
  }

  pressed(code: string) {
    return this.down.has(code);
  }

  held(code: string) {
    return this.keys.has(code);
  }

  private onKeyDown = (e: KeyboardEvent) => {
    if (e.repeat) return;
    if (["Space", "Tab"].includes(e.code)) e.preventDefault();
    this.keys.add(e.code);
    this.down.add(e.code);
  };

  private onKeyUp = (e: KeyboardEvent) => {
    this.keys.delete(e.code);
    this.up.add(e.code);
  };

  private onMouseDown = (e: MouseEvent) => {
    if (e.button === 0) this.fire = true;
    if (e.button === 2) this.ads = true;
  };

  private onMouseUp = (e: MouseEvent) => {
    if (e.button === 0) this.fire = false;
    if (e.button === 2) this.ads = false;
  };

  private onMouseMove = (e: MouseEvent) => {
    if (!this.locked) return;
    this.mx += e.movementX;
    this.my += e.movementY;
  };

  private onWheel = (e: WheelEvent) => {
    this.wheel += Math.sign(e.deltaY);
  };

  private onLock = () => {
    this.locked = document.pointerLockElement === this.canvas;
    if (!this.locked) {
      this.fire = false;
      this.ads = false;
    }
  };

  private clear = () => {
    this.keys.clear();
    this.fire = false;
    this.ads = false;
  };
}
